/**
 * Graph load helper used by the context-view bootstrap.
 *
 * All view types (compare, normal) use the split flow via runGraphRecalculation,
 * applying AI topics once they arrive (with a guard so we don't clobber a newer graph).
 * Compare mode passes additionalContexts and comparisonMode so the backend routes
 * through getMultiContextGraph instead of getFilteredGraph.
 */

import { runGraphRecalculation } from '../../utils/recalculateGraphFlow'
import { useZustand } from '../../hooks/useZustand'
import { useGraphStore } from '../useGraphStore'
import { useFilterStore } from '../useFilterStore'
import { formatTopicsFromClusters } from '../../utils/graphTopics'
import { isKeywordGraphApp } from '../../appVariant'

export const loadGraphData = async ({
    contextName,
    addContexts,
    compareMode,
    stopWords,
    isPublic,
    graphOwnerUsername,
}) => {
    let graphData = null
    let graphDataSnapshot = null

    await runGraphRecalculation({
        contextName,
        filteredStatementIds: [],
        stopWords,
        userName: isPublic ? graphOwnerUsername : null,
        additionalContexts: addContexts || [],
        comparisonMode: compareMode || null,
        onGraphData: data => {
            graphData = data
            useGraphStore.getState().setGraphData(data)
            graphDataSnapshot = useGraphStore.getState().graphData
        },
        onTopicsApplied: (_graphWithTopics, topicsExtension) => {
            const currentGraphData = useGraphStore.getState().graphData
            const currentContext = useZustand.getState().currentContext
            if (
                currentGraphData !== graphDataSnapshot ||
                currentContext !== contextName
            ) {
                return
            }

            useGraphStore.getState().applyTopicsExtension(topicsExtension)

            const updatedClusters =
                useGraphStore.getState().graphData?.entriesAndGraphOfContext
                    ?.graph?.graphologyGraph?.attributes?.top_clusters || []

            if (updatedClusters.length > 0) {
                const formattedTopics = formatTopicsFromClusters(
                    updatedClusters
                )
                useZustand.getState().setTopics(formattedTopics, true)
                // Set graph layer to topics by default for all graphs
                // if (!isKeywordGraphApp()) {
                // useZustand.getState().setCurrentGraphMode('topics')
                // }
                useFilterStore
                    .getState()
                    .updateFilteredStatementsWithCommunities()
            }
        },
    })

    return graphData
}
